import SEO from '../components/SEO/SEO'
import Hero from '../components/Hero/Hero'
import About from '../components/About/About'
import Services from '../components/Services/Services'
import Products from '../components/Products/Products'

export default function HomePage() {
  return (
    <>
      <SEO
        title="Jesse B Tattoos | Custom Tattoo Artist Adelaide"
        description="Jesse B Tattoos — bold, expressive custom tattoo work in Adelaide. Traditional-influenced, cartoon-styled, and completely personal. Book your session today."
        canonical="https://jessebtattoos.com.au/"
        keywords="tattoo artist Adelaide, Jesse B Tattoos, custom tattoos Adelaide, cartoon tattoos, traditional tattoos Adelaide"
        ogType="website"
      />
      <Hero />
      <About />
      <Services />
      <Products />
    </>
  )
}